import React ,{ useRef,forwardRef,useCallback } from 'react';
import { DatePicker,TimePicker } from 'antd';
import Cookies from 'universal-cookie';
import './Input.css';
import Map from "../../../views/Map.jsx";
import  MultiSelect from "react-multi-select-component";
import { useTranslation } from 'react-i18next';
// import {Autocomplete} from "@mui/material";
// import { Typeahead } from 'react-bootstrap-typeahead';
// import 'react-bootstrap-typeahead/css/Typeahead.css';
import  Select  from 'react-select'
import AsyncSelect from "react-select/async";
import 'assets/css/custom.css';
import moment from 'moment';
import CustomSwitch from 'components/CustomSwitch/CustomSwitch';
import { Domain } from 'environment/environment';
const cookies = new Cookies();

const InputField = ( props, ref ) => {
    const {setHasError} = props;
    const { t, i18n } = useTranslation();
    const selectRef = useRef(null);
    const debounceRef = useRef(null);
    const userRole_name = cookies.get("userRole_name").replace(/\s/g, "")  === 'WhitelistAdmin'  ? true : false
    const dateFormat = 'YYYY-MM-DD';
    const customerId = cookies.get("customer_id")

    const loadOptions = useCallback((inputValue, callback, endpoint,location_type) => {
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }
        debounceRef.current = setTimeout(() => {
            if(inputValue){
                props.fetchAsyncOptions(inputValue, endpoint, location_type).then(callback);
            }else{
                callback([]);
            }
        }, 300);
    }, []);
    
    const CustomClearIndicator = ({ innerProps }) => {
        return (
        <button style={{border:'none', background:'none'}} {...innerProps}>
          <i className="fa fa-remove" style={{fontSize:'16px', marginTop:'8px'}}></i>
        </button>
        )
    };

    let customStyles = {
        position: "relative",
        bottom: "-25px",
        right: "30px",
        cursor: "pointer",
        border: "none",
    } 
    
    let inputElement = null;

    let selectiveInputField = () => {
        return (
        <div>
            <select
             className="form-control"
             value={props.value}
             disabled={(props.elementConfig.readonly || props.elementConfig.disabled) ? true : false}
             onChange={props.changed}
             options= {props.elementConfig.options}>
                 {props.elementConfig.options.map((option) => {
                    let values = Object.values(props.elementConfig.options)
                    if(values.every((value) => value.hasOwnProperty('displayValue'))){
                    return <option key={option.value} value={option.value}>
                         {(option.displayValue !== null && option.displayValue.toString().toLowerCase()==='please select')? t(option.displayValue):(props.title === "Vendor Serial Number")?t(option.displayValue):option.displayValue} 
                     </option>
                 }
            })}
                 </select>
                 <span>{ (props.isValidate.required === true) ? 
                props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) :
                null}</span>
       </div>
        )
   }

   const filterOptions = (options, filter) => {
    try{
    if (!filter) {
      return options;
    }
    const filteredOptions = options.filter((obj => {
        if(obj.hasOwnProperty("label") && obj["label"] !== null){
            return obj.label.toLowerCase().includes(filter.toLowerCase())
        }
    }))
    return filteredOptions;
  }catch (e) {
   console.log(e)
  }
}

  const disabledFromDate = (current) => {
    try{
    if(current && current > moment().endOf('day')){
        return true
    }
    if(current && current > props.toDate && props.toDate !== ""){
        return true
    }
    if((props.title === "Dispatch" && customerId == 13 || customerId == 15) && props.toDate !== ""){
        const sixMonthsBefore = props.toDate.clone().subtract(6, 'months').startOf('day');
        return current && current.isBefore(sixMonthsBefore);
    }
    if(customerId == 5 && props.toDate !== ""){
        const ThreeMonthsBefore = props.toDate.clone().subtract(3, 'months').startOf('day');
        return current && current.isBefore(ThreeMonthsBefore);
    }
    }catch (e) {
    console.log(e)
  }
  };

  const disabledToDate = (current) => {
    try{
    if(current && current > moment().endOf('day')){
        return true
    }
    if(current && current < props.fromDate){
        return true
    }
    if((props.title === "Dispatch" && customerId == 13 || customerId == 15) && props.fromDate !== ""){
        const sixMonthsLater = props.fromDate.clone().add(6, 'months').endOf('day');
        return current && current.isAfter(sixMonthsLater);
    }
    if(customerId == 5 && props.fromDate !== ""){
        const threeMonthsLater = props.fromDate.clone().add(3, 'months').endOf('day');
        return current && current.isAfter(threeMonthsLater);
    }
  }catch (e) {
    console.log(e)
  }
}

  

   let renderView = () => {
    return props.visible && props.id == 'component_type' ? selectiveInputField()
    : props.show && props.id == 'components' ? selectiveInputField()
    :
    <>
    <div>
    <select
     className="form-control"
     value={props.value}
     disabled={(props.elementConfig.readonly || props.elementConfig.disabled) ? true : false}
     onChange={props.changed}
     options= {props.elementConfig.options}>
         {props.elementConfig.options.map((option) => {
                    let values = Object.values(props.elementConfig.options)
                    if(values.every((value) => value.hasOwnProperty('displayValue'))){
                    return <option key={option.value} value={props.title === 'Pairing' || props.title === 'Lot Creation' ? option.displayValue : option.value}>
                         {(option.displayValue !== null && option.displayValue.toString().toLowerCase()==='please select')? t(option.displayValue):(props.title === "Vendor Serial Number")?t(option.displayValue):option.displayValue} 
                     </option>
                 }
            })}
         </select>
         <span>{ (props.isValidate.required === true) ? 
        props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) :
        null}</span>
</div> 
</>
   }

    window.pressed = function(e) {
        props.fileUpload(e.target.files[0])
        let a = document.getElementById('files');
        let b = document.getElementById('fileLabel')
        if (a.value == "") {
          b.innerHTML = "Choose file";
        } else {
          let theSplit = a.value.split('\\');
          b.innerHTML = theSplit[theSplit.length - 1];
        }
      };
      (props.elementConfig.placeholder) =t(props.elementConfig.placeholder)

    switch (props.elementType ) {
        case('input'):
        (props.id == 'password') && props.setPassVal(props.value);
        (props.id == 'capacity')  && Object.keys(props.tableList).length > 0 && props.setCapacity(props.value);
        (props.id == 'qty')  && Object.keys(props.tableList).length > 0 && props.setQty(props.value);
        (props.id == 'Primary - Gift Box Quantity')  && Object.keys(props.tableList).length > 0 && props.setQuantity(props.value);
        (props.id == 'sequence') &&  Object.keys(props.tableList).length > 0 && props.setSequence(props.value)
            inputElement =
                <div>
                    {(props.id == 'confirm_password') ?
                        <div>
                            <input
                                className="form-control"
                                {...props.elementConfig}
                                value={props.value}
                                onChange={props.changed} />
                            <span>{(props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, `required|in:${props.passVal}`, { messages: { in: `${t('password_match')}` } }) : null}</span>
                        </div>
                        :
                        (props.id == 'po_number') ?
                            <div>
                                <input
                                    className="form-control"
                                    {...props.elementConfig}
                                    value={props.value}
                                    disabled={props.readonly ? true : false}
                                    onChange={props.changed} />
                                <span>{(props.isValidate.required === true) && props.validater.message(props.id, props.value, ['required', { regex: /^[^\s]+$/ }], { messages: { regex: "The po number doesn't contain spaces" } })}</span>
                            </div>
                            :
                            <div>
                                {((props.id == 'qty' || props.id == 'capacity' || props.id == 'Primary - Gift Box Quantity' || props.id === 'Quantity' || props.id === 'weight' || props.id === 'sequence'|| props.id === "sortOrder") && Object.keys(props.tableList).length !== 0) ?
                                    <div>
                                        {(props.capacity || props.level || props.qty || props.material || props.sequence || props.toDate) && (props.id == 'capacity' || props.id == 'qty' || props.id === 'Quantity' || props.id == 'sequence') ?
                                            <span>
                                                <input
                                                    className="form-control"
                                                    {...props.elementConfig}
                                                    accept=".png"
                                                    value={props.value}
                                                    readOnly={props.id === 'sequence' && props.disabledOnCheck === true ? true : false}
                                                    onChange={props.changed} />
                                                <span>{(props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : null}</span>
                                            </span>
                                            :
                                            <input
                                                className="form-control"
                                                {...props.elementConfig}
                                                accept=".png"
                                                value={props.value}
                                                readOnly={props.id === 'sequence' && props.disabledOnCheck === true ? true : false}
                                                onChange={props.changed} />}
                                    </div>
                                    :
                                    (props.visible && props.id === 'part_number') ?
                                        <span>
                                            <input style={{ marginTop: "7px" }}
                                                className="form-control"
                                                {...props.elementConfig}
                                                accept=".png"
                                                value={props.value}
                                                readOnly={props.elementConfig.readonly ? true : false}
                                                onChange={props.changed} />
                                            <span>{(props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : null}</span>
                                        </span>
                                        :
                                        <span>
                                            <input
                                                className="form-control"
                                                {...props.elementConfig}
                                                accept=".png"
                                                disabled = {props.elementConfig.disable}
                                                value={props.value}
                                                readOnly={(props.id === 'sequence' || props.id === "transactionGroupName") ? props.disabledOnCheck === true ? true : false : props.elementConfig.readOnly ? props.elementConfig.readOnly : props.readonly}
                                                onChange={props.changed}
                                                min={props.id === "qty" && (props.title === "Generate IOT" || props.title === "Delivery") ? 0 : null}
                                                maxLength={props.isValidate?.max}
                                                />
                                            <span>{(props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, (props?.qtyValidation && props.title === "Generate IOT" ) ? `required|integer|min:1,num|not_in:0|max:${props?.qtyValidation},num` : props.isValidate.rules) : null}</span>
                                        </span>
                                }
                            </div>
                    }
                </div>;
                break;
        case('file'):
            inputElement =
                <div>
                    {(props.titlePreFix == `${t('edit')}`) ?
                        <div>
                            {(props.imagePath !== undefined) ?
                                <div>
                                    <img src={props.tempImg ? props.tempImg : props.imagePath.props.children.props.src} alt="no img" width="50" height="50" />
                                    {props.wizardData && (<h6 className='editImage'>{props.wizardData.productsDetail.data.data1.imgurl}</h6>)}
                                    <input
                                        // className="form-control"
                                        style={{ color: props.wizardData.productsDetail.data.data1.imgurl ? 'rgba(0,0,0,0)' : 'black' }}
                                        {...props.elementConfig}
                                        onChange={props.changed}
                                    />
                                </div>
                                :
                                <div>
                                    {props.tempImg !== undefined ?
                                        <img src={(props.tempImg)} alt="no img" width="50" height="50" />
                                        : ''}
                                    <input
                                        //className="form-control"
                                        {...props.elementConfig}
                                        onChange={props.changed}
                                    //value={props.tempImg}
                                    /></div>

                            }
                        </div>
                        :
                        i18n.language === "chi" ?
                            <>
                                <label for="files" className="btn btn-outline-primary btn-rounded waves-effect"> {`${t("choose_file")}`} </label>
                                <input
                                    type="file"
                                    style={{ display: "none" }}
                                    id="files"
                                    onChange={(e) => window.pressed(e)} />
                                <label id="fileLabel">{`${t("no_file_choosen")} `}</label>
                            </>
                            :
                            <div>
                                {(props.labelName === 'Upload Image') ?
                                (props.imgSize < 1) && props.tempImg !== undefined ?
                                    <div>
                                        {props.selectedImages?.blobFile &&
                                            props.selectedImages.blobFile.map((image, index) => {
                                                return (
                                                    <div>
                                                        <img src={(image)} style={{ marginLeft: '1em', marginBottom: '20px' }} alt="no img" width="50" height="50" />
                                                        <a style={customStyles} onClick={(e) => props.deleteHandler(image)}><i className="fa fa-trash-o fa-delete"></i></a>
                                                    </div>
                                                );
                                            })}
                                    </div> : <span style={{color:'#D54C2F'}}>{`${t("alerts.upload_image")}`}</span>
                                    : " "}
                                {props?.customFile ? '' : 
                                <input
                                    id="files1"
                                    ref={ref}
                                    {...props.elementConfig}
                                            onChange={props.changed}
                                //value={props.tempImg}
                                        />}
                                <span>{ (props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : null}</span>
                            </div>
                    }
                    {/* <img src={value.image} alt="no img" width="50" height="50" /> */}
                    {/* <span style={{borderRadius:20,float:"left"}} className="btn btn-outline-primary btn-rounded waves-effect" onClick={props.uploadFunc}> Upload </span> */}
                </div>;
                break;
        case('anchor'):
         const isGlobal = props.title === 'Global Settings';
        const isEdit = props.titlePreFix === 'Edit';
        const hrefLink = isGlobal
        ? `${Domain}/${props.dropDownData?.downloadSample?.replace(/^public\//, '')}`
        : isEdit
        ? `${Domain}/${props.value?.replace(/^public\//, '')}`
        : props.value;
          
        inputElement =<div>
             {(props.template === true) ? " " :
            <span>
             <a
                //className="form-control"
                href={hrefLink}
              //  href='http://www.africau.edu/images/default/sample.pdf'
                {...props.elementConfig}
               // onChange={props.changed}
            >{`${t('click_download')}`}</a>
            </span>}
            </div>;
                break;
        case('textarea'):
            inputElement = <div>
                {/* { (props.id == 'Remarks')  && Object.keys(props.tableList).length > 0 && props.setRemarks(props.value)} */}
                {/* <div> */}
{/* {((props.id == 'Remarks')  && Object.keys(props.tableList).length !== 0) ? 
<div>
     {(
         //props.price || 
         props.toDate) &&
      (props.id == 'Remarks') ?
       <span>
       <textarea 
       rows="1"
        className="form-control"
        {...props.elementConfig}
        value={props.value}
        onChange={props.changed}
        />
        <span>{ (props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : null}</span>
      </span>
     :
     <textarea 
     rows="1"
     className="form-control"
     {...props.elementConfig}
     value={props.value}
     onChange={props.changed}
     />
    }
</div>
: */}
{(props.id == 'template') ?
<span>
<textarea 
rows="8"
 className="form-control"
 {...props.elementConfig}
 value={props.value}
 onChange={props.changed}
 />
 <span>{ (props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules, { className: props.id }) : null}</span>
</span> :
(props.id === 'whitelist_ip' && !userRole_name)  ?
<div>
    <textarea
        rows='2'
        className="form-control"
        {...props.elementConfig}
        value={props.value}
        onChange={props.changed} />
    <span>{(!props.disabledOnCheck?.whiteList && props.isValidate.required === false) ? props.validater.message(props.elementConfig.placeholder, props.value, ['required' , {regex:/^(?!.*,).+$/gm}], { messages: { regex: "The Whitelist IP doesn't contain comma" } }) : null}</span>
</div>:
(props.id === 'generate')  ?
<div>
    <textarea style={{resize: 'both', maxWidth: '570px', width: '100%', boxSizing: 'border-box'}}
        rows='2'
        className="form-control"
        {...props.elementConfig}
        value={props.value}
        onChange={props.changed} />
    <span>{(!props.disabledOnCheck?.whiteList && props.isValidate.required === false) ? props.validater.message(props.elementConfig.placeholder, props.value, ['required' , {regex:/^(?!.*,).+$/gm}], { messages: { regex: "The Whitelist IP doesn't contain comma" } }) : null}</span>
</div>
:
<span>
<textarea 
rows="2"
 className="form-control"
 {...props.elementConfig}
 value={props.value}
 onChange={props.changed}
 />
 
 <span>{ (props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : null}</span>
</span>}
{/* }
</div> */}
                {/* <textarea 
                className="form-control"
                {...props.elementConfig}
                value={props.value}
                onChange={props.changed}
                // rows="3"
                // columns="15"
                />
                <span>{ (props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : null}</span> */}
                </div>
            break;
            case('invisible'):
            inputElement =<div>

            </div>
            break;
            case('textareaMoreHeight'):
            inputElement = <div>
                <textarea 
                rows="10"
                className="form-control"
                {...props.elementConfig}
                value={props.value}
                onChange={props.changed}
                />
                
                <span>{ (props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : null}</span>
            </div>
            break;
        case('textareaWithoutMandatory'):
            inputElement = <div>     
            <textarea 
            rows="1"
            className="form-control"
            {...props.elementConfig}
            value={props.value}
            onChange={props.changed}
            />
            <span>{ (props.isValidate.required === false) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : null}</span>
        </div>
        break;
        case('select'):
                        (props.id == 'product_type' && props.value == 8005 ) && props.setVisible(false) ;
            (props.id == 'product_type' && props.value != 8005 ) && (cookies.get("customer_id") == 17 ? props.setVisible(false) : props.setVisible(true)) ;
            (props.id == 'product_type' && props.value == 8001) && props.setShow(false);
            (props.id == 'product_type' && props.value != 8001) && props.setShow(true);
            (props.id == 'product_type' && (props.value == 8001 || props.value == 8005)) && props.setToggle(false);
            (props.id == 'product_type' && (props.value == "" || props.value == 8003)) && props.setToggle(true);
            ((props.id == 'product_type' && (props.value == 8002 || props.value == 8003 || props.value == 8001)) && (cookies.get("customer_id") == 5)) && props.setVisible(false) ;
            inputElement = <div> {renderView()} </div>
            break;
        case('selectshowlabel'):
        (props.id == 'level') && Object.keys(props.tableList).length > 0 && props.setLevel(props.value);
        // (props.id == 'uom') && Object.keys(props.tableList).length > 0 && props.setUOM(props.value);
        (props.id == 'material') && Object.keys(props.tableList).length > 0 && props.setMaterial(props.value);
        (props.id == 'location') && Object.keys(props.tableList).length > 0 && props.setLocation(props.value);
        (props.id == 'product_group') && Object.keys(props.tableList).length > 0 && props.setProductgroup(props.value);
        (props.id == 'product') && Object.keys(props.tableList).length > 0 && props.setProduct(props.value);
        
        inputElement = <div>
             {((props.id === 'level' || props.id === 'material' || props.id === 'product'
            //   || props.id === 'uom'
             || props.id === 'location' || props.id === 'product_group')
                 && Object.keys(props.tableList).length !== 0) ?
                 <span>
                 {(props.capacity 
                //  || props.UOM 
                 || props.level || props.qty || props.material || props.quantity
                 || props.location || props.product || props.productgroup) && 
                 (props.id == 'level' 
                //  || props.id == 'uom' 
                 ||  props.id == 'material' || props.id == 'product' ||
                 props.id == 'location' ||  props.id == 'productgroup') ?
                 <span>
                 <select 
            className="form-control" 
            value={props.value}
            onChange={props.changed}>
            {props.elementConfig.options.map(option => (
                <option key={option.value} value={option.displayValue}> {option.displayValue} </option>
            ))}
            </select>
            <span>{ (props.isValidate.required === true) ? 
            props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : 
            null}</span></span>
                :
                <select 
                    className="form-control" 
                    value={props.value}
                    onChange={props.changed}>
                    {props.elementConfig.options.map(option => (
                                                //  {(option.displayValue.toLowerCase()==='please select')? t(option.displayValue):option.displayValue} 

                        <option key={option.value} value={option.displayValue}> {option.displayValue} </option>
                    ))}
                </select>
                 }</span>
                 :
                 <span>
                      <select 
                 className="form-control" 
                 value={props.value}
                 onChange={props.changed}>
                 {props.elementConfig.options.map(option => (
                     <option key={option.value} value={option.displayValue}> {option.displayValue} </option>
                 ))}
                 </select>
                 <span>{ (props.isValidate.required === true && Object.keys(props.tableList).length === 0) ? 
                 props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : 
                 null}</span>
                 </span>
                  }
        </div>;
        break;
        case 'asyncSelect':
            inputElement = <div>
                 <AsyncSelect
                    cacheOptions
                    loadOptions={(inputValue, callback) => loadOptions(inputValue,callback,props.elementConfig.asyncEndpoint, props.elementConfig?.location_type)}
                    defaultOptions
                    isDisabled={props.elementConfig.asyncEndpoint ? false : props.titlePreFix === "Edit" ? false : true}
                    onChange={props.changed}
                    placeholder="Search..."
                    isLoading={false}
                    value={props.value}
                    />
            </div>
            break
        case('checkbox'):
        inputElement = <div>
            <input
            className="custom-control-input"
            {...props.elementConfig}
            checked={props.value}
            onChange={props.changed}
            /> 
              <span>{ (props.isValidate.required === true) ? props.validater.message(props.id, props.value, props.isValidate.rules) : null}</span>
        </div>;
        break;
        case('selectshowsearch'):
        (props.id == 'material') && Object.keys(props.tableList).length > 0 && props.setMaterial(props.value);
        (props.id == 'product') && Object.keys(props.tableList).length > 0 && props.setProduct(props.value);
        (props.id == 'transaction') && Object.keys(props.tableList).length > 0 && props.setTransaction(props.value);
        let array = []
        const someProperty = {...props}
        const defaultVendorBulkDownload = (props.title === "IOT Bulk Download" && props.id === 'vendorId') && !(cookies.get('userRole_name') === 'Super Admin');
            const modifyOptions = props.elementConfig.options.map(obj => {
                if (obj.label) {
                    return obj;
                }
                const { displayValue, ...rest } = obj;
                return { ...rest, label: displayValue };
            });
        inputElement = <div>
        {((props.id === 'material' || props.id == 'product' || props.id == 'transaction' || props.id == "transactions") && Object.keys(props.tableList).length === 0) ?
        <span>
        <Select
           ref={selectRef}
           isClearable
           isSearchable
           placeholder={`${t("search")}...`}
           closeMenuOnSelect={true}
           onChange={props.changed}
           value={props.value}
           isDisabled={props.id === 'transaction' && props.disabledOnCheck.transaction === true || props.elementConfig.readOnly ? true : false}
           options= {modifyOptions}
           components={{
            ClearIndicator: CustomClearIndicator,
          }}
        />
            <span>{ (props.isValidate.required === true) ? 
                props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) :
                null}
            </span>
        </span>
        :
            <span>
            <Select
               ref={selectRef}
               isClearable
               isSearchable
               placeholder={`${t("search")}...`}
               closeMenuOnSelect={true}
               onChange={props.changed}
               value={defaultVendorBulkDownload ? modifyOptions[0] : props.value}
               isDisabled={(props.id === 'transaction' && props.disabledOnCheck.transaction) || defaultVendorBulkDownload || props.elementConfig.readOnly ? true : false}
               options= {modifyOptions}
               components={{
                ClearIndicator: CustomClearIndicator,
              }}
            // options={(option.displayValue.toLowerCase()==='select...')? t(option.displayValue):option.displayValue} 
            />
            <span>{(someProperty?.labelName === 'Choose PO*' && props?.isValidate.required === true) || (props.hasOwnProperty('tableList') === true && Object.keys(props?.tableList).length === 0 && someProperty?.labelName === 'To location*') || 
            ( props.title === "Support" ? props.isValidate.required === true : props.isValidate.required === true && Object.keys(props?.tableList).length === 0) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) :null}
            </span>
            </span>
            }
         </div>;
        break;
        case('radio'):
    inputElement = <div>
    {((props.value == 'Initiated' || props.value == 1 || props.value == 0) && props.value != 'Approved' && props.value != 'Rejected') ?
    <div>
        
        <span onChange={props.changed}>
        <input type="radio" value="1" name="action"/> Approve 
        <input type="radio" value="0" name="action" style={{marginLeft:"10px"}} /> Reject
        </span>
        <span>{ (props.isValidate.required === true) ? props.validater.message(props.id, props.value, props.isValidate.rules) : null}</span>
    </div>  
    :
    <div>
        <span>
        <input type="radio" disabled value="1" name="action" checked={props.value == 'Approved' ? true: false}/> Approve 
        <input type="radio" disabled value="0" name="action" checked={props.value == 'Rejected' ? true: false} style={{marginLeft:"10px"}} /> Reject
        </span>
    </div>
    }
             
</div>;
        break;
        case("switch"):
            inputElement = (
                <> 
                    <CustomSwitch changed={props.changed} checked={props.value} />
                </>
            )
            break;
        case('date'):
            inputElement =<div>
                <DatePicker
                        className="form-control"
                        {...props.elementConfig}
                        format={dateFormat}
                        defaultValue={moment()}
                        value={props.value}
                        onChange={(date, dateString) => props.changed(dateString)}x
                        disabledDate={current => current && current > moment().endOf('day')}
                    />
                    <span>{ (props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : null}</span>
            </div>;
        break;
        case('from_date'):
        props.setFromDate(props.value);
            inputElement = <div>
                <DatePicker
                    className="form-control"
                    {...props.elementConfig}
                    format={dateFormat}
                    defaultValue={moment()}
                    disabledDate={disabledFromDate}
                    value={props.value}
                    placeholder="From Date"
                    onChange={(date, dateString) => props.changed(dateString)}
                />
                <span>{(props.toDate) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : (props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : null}</span>
            </div>;
        break;
        case('to_date'):
        props.setToDate(props.value);
            inputElement = <div>
                <span>
                    <DatePicker
                        className="form-control"
                        {...props.elementConfig}
                        format={dateFormat}
                        defaultValue={moment()}
                        disabledDate={disabledToDate}
                        value={props.value}
                        onChange={(date, dateString) => props.changed(dateString)}
                    />
                    <span>{(props.fromDate) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : (props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : null}</span>
                </span>
            </div>;
    break;
    case('time_range'):
            inputElement = <>
                <TimePicker.RangePicker
                    className="form-control"
                    onChange={(times, timeString) => props.changed(times)}
                    value={props.value}
                    showNow={false}
                    use12Hours={false}
                    placeholder={["HH:MM:SS","HH:MM:SS"]}
                />
                <span>{ (props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : null}</span>
            </>
    break
    case('applicable_from_date'):
      inputElement =<div>
                <input 
                    className="form-control"
                    {...props.elementConfig}
                    value={props.value}
                    inputProps={{readOnly:true}}
                    min={moment().add(1,'days').format("YYYY-MM-DD")}
                    onChange={props.changed}/>
                    <span>{(props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : null}</span> 
                    </div>;
        break;
        case('multiselect'):
       inputElement =
        (props.visible && props.id == 'component') ?   ''
          :
        <div> 
            <MultiSelect
           {...props.elementConfig}
                placeholder={`${t("search")}...`}

                options={props.elementConfig.options ? props.elementConfig.options : []} 
                labelledBy="Please select"
                value={props.value}
             // value={props.elementConfig.options.filter(obj => props.mult.includes(obj.value))} 
                onChange={props.changed}
                filterOptions={filterOptions}
                disabled={(props.elementConfig.readonly || props.elementConfig.disabled) ? true : false}
                disableSearch={(props.elementConfig.readonly || props.elementConfig.disabled) ? true : false}
               hasSelectAll={(!(props.elementConfig.options) || Object.keys(props.elementConfig.options).length <= 0) ? false : true}
               className={props.elementConfig.readonly || props.elementConfig.disabled ? "multi-select-disabled" : ""}

          overrideStrings={
          {search: `${t("Search")}`,selectSomeItems: `${t("Select")}`}

                }
            />
            <span>{ (props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : null}</span>
        </div>;
        break;
        case('maps'):
              inputElement =
              <Map
                google={props.google}
                center={props.center}
                height='200px'
                zoom={12}
                address={props.address}
                city={props.city}
                area={props.area}
                state={props.state}
                lat = {props.lat}
                lan = {props.lan}
                setLat = {props.setLat}
                setLan = {props.setLan}  
                country={props.country}  
                mapPosition={props.mapPosition}
                markerPosition={props.markerPosition}   
                setAddress={props.setAddress}
                setCity={props.setCity}
                setArea={props.setArea}
                setState={props.setState}
                setCountry={props.setCountry}
                setMapPosition={props.setMapPosition}
                setMarkerPosition={props.setMarkerPosition}   
              />                                                                                                                    
        break;
        default:
            inputElement =
                <>
                    <input
                        className="form-control"
                        value={props.value}
                        {...props.elementConfig}
                        onChange={props.changed}></input>
                    <span>{(props.isValidate.required === true) ? props.validater.message(props.elementConfig.placeholder, props.value, props.isValidate.rules) : null}</span>
                </>
    }

    return(
        props.visible && (props.id == 'component') ?
        '':
        (!props.disabledOnCheck?.whiteList && props.id === "whitelist_ip") ? '' 
        // (props.toggle === "Reference Id*" && props.id === "reference_id") ?
        :
        (props.show === false && props.id === "components") ?
        <div style={{marginTop :"-6em"}} >
        <label className="Label" > { props.labelName } </label>
        {inputElement}
        </div>
        :
        props.toggle && (props.id == 'component_type') ? " "
        /* // // :
        // <div className="" >
        // <label className="Label" > { props.labelName } </label>
        // {inputElement}
        // </div> */
        :
        props.show && (props.id == 'components') ?
        '':
        // (props.toggle === "Reference Id*" && props.id === "reference_id") ?
        (props.show === false && props.id === "components") ?
        <div style={{marginTop :"-6em"}} >
                 <label className="Label" > { props.labelName } </label>
               {inputElement}
          </div>:
        /* // //  :
        //  <div className="" >
        //         <label className="Label" > { props.labelName } </label>
        //         {inputElement}
        //  </div> */
        //  :(props.toggle === "Batch Id*" && props.id === "batch_id") ?
        //  <div className=""  >
        //         <label className="Label" > { props.labelName } </label>
        //         {inputElement}
        //  </div>
        props.show && (props.id == 'components') ?
            '':
            <div className={props.labelName === "Activate SAP" && "switch-label-container"} >
                <label className={props.labelName === "Activate SAP" ? "switch-label" : "Label"} > { t( props.labelName) } </label>
                {inputElement}
         </div>
    )
}

export default forwardRef(InputField);
 